import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/bell_icon.png'
import _imports_1 from '@/assets/images/expand_more.svg'


const _hoisted_1 = { class: "main-header" }
const _hoisted_2 = { class: "bell-icon-div" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "bell-icon",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "profile-div" }
const _hoisted_5 = { class: "h5-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_tooltip, {
          class: "round-div",
          text: _ctx.notificationTooltip,
          positionFromTop: _ctx.headerTooltipPosition
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["text", "positionFromTop"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_tooltip, {
          text: _ctx.profileTooltip + _ctx.userFullName + ' 🙂',
          positionFromTop: _ctx.headerTooltipPosition
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "profile-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToProfile()))
            }, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.userTag), 1)
            ])
          ]),
          _: 1
        }, 8, ["text", "positionFromTop"]),
        _createVNode(_component_tooltip, {
          class: "round-div",
          showTooltip: !_ctx.isDropdownOpen,
          text: _ctx.menuTooltip,
          positionFromTop: _ctx.headerTooltipPosition
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              ref: "dropdown",
              class: "menu-icon",
              src: _imports_1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDropdown()))
            }, null, 512)
          ]),
          _: 1
        }, 8, ["showTooltip", "text", "positionFromTop"])
      ])
    ]),
    (_ctx.isDropdownOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dropdown",
          onClickout: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDropdown()))
        }, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToProfile())),
            class: "dropdown-element medium-text"
          }, _toDisplayString(_ctx.$t("component-main-header.profile")), 1),
          _createElementVNode("a", {
            class: "dropdown-element medium-text",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.userLogout && _ctx.userLogout(...args)))
          }, _toDisplayString(_ctx.$t("component-main-header.logout")), 1)
        ], 32))
      : _createCommentVNode("", true)
  ]))
}